import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiCompanyService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import {
    DtgManageEtasCarFormComponent
} from "src/app/dtg/manage/etas/car/form/dtg.manage.etas.car.form.component";

@Component({
    selector: "dtg-manage-etas-car-list"
    ,templateUrl: './dtg.manage.etas.car.list.component.html'
    ,providers: []
})
export class DtgManageEtasCarListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    listCar:any[];
    @Input() listType:DtgListType = DtgListType.list;
    searchValue:string;
    userGroupId:number;
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    dtgTeamId:string;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiCompanyService:FvmsApiCompanyService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.pagingInfo.pageSize = 15;
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.reloadListItem();
            });
     }

    ngOnInit() {
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    clickSearch(){
        this.reloadListItem();
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem();
    }

    reloadListItem(){
        let searchInfo = {
            dtgEid:this.companyInfo.dtgEid
            ,searchValue:this.searchValue
        };
        this.fvmsApiCompanyService.findAllEtasCarPaging(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listCar = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickOpenModalFormEtasCar(dtgActionType:DtgActionType,dtgEtasCar:any){
        let modalRef = this.modalService.open(
            DtgManageEtasCarFormComponent
            ,{
                centered:true
                // ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.dtgEid = dtgEtasCar?.dtgEid;
        modalRef.componentInstance.dtgUnitId = dtgEtasCar?.dtgUnitId;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        this.reloadListItem();
                    }
                    break;
                default:
                    break;
            }
        });
    }
}